<script>
export default {
  name: 'OnboardingCompleteStep',
  computed: {
    accountId() {
      return this.$route.params.accountId;
    },
  },
  methods: {
    handleGoToDashboard() {
      this.$router.push({
        name: 'home',
        params: { accountId: this.accountId },
      });
    },
  },
};
</script>

<template>
  <div
    class="flex flex-col items-center justify-center gap-6 p-6 md:p-10 w-full h-full text-center"
  >
    <span class="text-5xl leading-none">🎉</span>
    <div class="flex flex-col gap-2 max-w-md">
      <h2 class="text-2xl font-medium text-slate-900 dark:text-slate-100">
        {{ $t('ONBOARDING_SHELL.STEPS.COMPLETE.HEADING') }}
      </h2>
      <p class="text-sm text-slate-500 dark:text-slate-400">
        {{ $t('ONBOARDING_SHELL.STEPS.COMPLETE.SUBHEADING') }}
      </p>
    </div>

    <div
      class="flex flex-col gap-2 text-left text-sm text-slate-600 dark:text-slate-300"
    >
      <div class="flex items-center gap-2">
        <fluent-icon icon="checkmark" size="14" class="text-green-500" />
        {{ $t('ONBOARDING_SHELL.STEPS.COMPLETE.RECAP_KNOWLEDGE_BASE') }}
      </div>
      <div class="flex items-center gap-2">
        <fluent-icon icon="checkmark" size="14" class="text-green-500" />
        {{ $t('ONBOARDING_SHELL.STEPS.COMPLETE.RECAP_SANDBOX') }}
      </div>
      <div class="flex items-center gap-2">
        <fluent-icon icon="checkmark" size="14" class="text-green-500" />
        {{ $t('ONBOARDING_SHELL.STEPS.COMPLETE.RECAP_CHANNEL') }}
      </div>
    </div>

    <woot-button
      data-testid="onboarding_complete_cta_button"
      @click="handleGoToDashboard"
    >
      {{ $t('ONBOARDING_SHELL.STEPS.COMPLETE.CTA') }}
    </woot-button>
  </div>
</template>
